import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';

import { StepControl } from '@speeki/global-ui-components';

import { Loader } from '@components/_universal/Loader/Loader';
import { Card } from '@components/molecules/Card/Card';
import { ColumnsLayout } from '@components/templates/ColumnsLayout/ColumnsLayout';

import { TenantMfaSettingsDocument } from '@graphql/generated/graphql';

import { useQueryParam } from '@utils/hooks/useQueryParam';

import { AuthService } from '@services/AuthService/AuthService';
import { useCheckResetToken } from '@services/AuthService/useCheckResetToken';
import { getPath } from '@services/RouteService/paths';

import { useQuery } from '@apollo/client';
import { StepControlWrapper } from '@domains/auth/ions/cards';
import { ResetPasswordForm } from '@domains/auth/organisms/ResetPasswordForm/ResetPasswordForm';

// TODO: SPD-3621 refactor during new auth flow

export const ResetPasswordPage = () => {
    const tenantUuid = AuthService.getTenantUuid();
    const { t } = useTranslation();

    const code = useQueryParam('code') || '';

    const { loading } = useCheckResetToken(code);
    const { data } = useQuery(TenantMfaSettingsDocument, {
        skip: !tenantUuid,
        variables: {
            uuid: tenantUuid || '',
        },
    });
    const showSteps = data?.tenant.enforceMfa;

    if (!code) return <Navigate to={getPath({ path: '/auth/welcome' })} />;

    return (
        <Loader isLoading={loading}>
            <ColumnsLayout>
                <Card testId="OptLGZG">
                    <Card.TitleTertiary>
                        {t('FORGOT_PASSWORD_RESET_PASSWORD')}
                    </Card.TitleTertiary>
                    <Card.Description>
                        {t('FORGOT_PASSWORD_FORM_SUBTITLE')}
                    </Card.Description>
                    <ResetPasswordForm code={code} />
                    {showSteps && (
                        <StepControlWrapper>
                            <StepControl
                                activeStep={1}
                                length={2}
                                testId="Iv5-VhQ"
                                variant="dark"
                            />
                        </StepControlWrapper>
                    )}
                </Card>
            </ColumnsLayout>
        </Loader>
    );
};
